import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { CardContext, forceMobile } from '../generics';
import CellBase from './cell-base';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var ProductTableCellCta = function ProductTableCellCta(_ref) {
  var primary = _ref.primary,
      secondary = _ref.secondary,
      headerImage = _ref.headerImage,
      _ref$isWireFrame = _ref.isWireFrame,
      isWireFrame = _ref$isWireFrame === void 0 ? false : _ref$isWireFrame;

  var _React$useContext = React.useContext(CardContext),
      isCard = _React$useContext.isCard;

  var forcedMobile = forceMobile(isCard);
  var buttonWrapperStyling = {
    flex: forcedMobile([1, null, 'initial']),
    width: forcedMobile(['auto', '100%']),
    display: forcedMobile(['flex', null, 'block']),
    variant: headerImage ? 'compounds.product-table.variants.redesign.cellCta.buttonWrapper' : 'compounds.product-table.cellCta.buttonWrapper'
  };
  return _jsxs(CellBase, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: forcedMobile(['column', 'row', 'column']),
      opacity: isWireFrame ? 0.4 : 1,
      variant: 'compounds.product-table.cta'
    },
    children: [_jsx("div", {
      sx: _objectSpread({}, buttonWrapperStyling),
      children: primary
    }), secondary && _jsx("div", {
      sx: _objectSpread({}, buttonWrapperStyling),
      children: secondary
    })]
  });
};

export default ProductTableCellCta;
//# sourceMappingURL=cell-cta.js.map